<template>
    <section>
		<app-loading :show-loading="loadingButton" />
      	<header-page
			name="detail-billing"
			:title="$route.meta.title"
		/>
		<v-layout pt-4 pb-2 pl-5>
			<v-flex xs2>
				<date-component
					label="Fecha de Envió"
					:date-formatted="params.dateBilling"
					model="dateBilling"
					@input="setDate({ model: 'dateBilling', value: $event })"
				/>
			</v-flex>
			<v-flex xs2 ml-3 pt-3>
				<v-select
					background-color="white"
					box
					multiple
					clearable
					class="body-1"
					hide-details
					item-text="name"
					item-value="id"
					label="Estado"
					:items="states"
					return-object
					v-model="statusTax"
				></v-select>
			</v-flex>
			<v-flex xs2 ml-3 mt-3>
				<button
					class="btn-search"
					@click="loadDetail"
				>
					Buscar
				</button>
			</v-flex>
			<v-flex xs5 text-xs-right pt-3 ml-3>
				<v-btn
					:disabled="!dataSelected.length > 0"
					class="pa-2 px-3"
					color="primary"
					small
					@click="sendKardex"
				>
					Reenviar Facturación
				</v-btn>
			</v-flex>
		</v-layout>
		<div class="px-5">
			<app-table
				class="my-5 is-not-selectable pb-4"
				:columns="columns"
				:current-page="currentPage"
				:rows="rows"
				:last-page="lastPage"
				:check-all="checkAll"
				:selected-value="selectedValue"
				selectable
				@on-search-event="onSearch"
				@on-page="changePage"
				@row-is-selected="rowIsSelected"
				@on-selected-all="allIsSelected"
			>
				<template slot="rows" slot-scope="props">
					<td v-show="showRow(columns, 1)" class="is-not-selectable width-1">
						{{ props.row.idSummary }}
					</td>
					<td
						class="is-not-selectable"
						v-show="showRow(columns, 2)"
					>
						{{ props.row.summaryType }}
					</td>
					<td v-show="showRow(columns, 3)">
						{{ props.row.numericalIdentification }}
					</td>
					<td v-show="showRow(columns, 4)">
						{{ props.row.totalDoc }}
					</td>
					<td v-show="showRow(columns, 5)" class="width-error">
						{{ props.row.sunatError }}
					</td>
					<td v-show="showRow(columns, 6)" class="width-1">
						{{ props.row.emisionDate }}
					</td>
					<td v-show="showRow(columns, 7)" class="width-1">
						{{ props.row.referenceDate }}
					</td>
					<td v-show="showRow(columns, 8)">
						<app-tooltip-button
							color="green"
							icon="send"
							text="Reenviar Facturación"
							@click-icon="sendKardex(props.row)"
						/>
					</td>
				</template>
			</app-table>
		</div>
    </section>
</template>

<script>
import { format } from 'date-fns';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import dateComponent from '@/components/shared/date-component';
import appLoading from '@/components/shared/app-loading';

function created() {
	this.params.dateBilling = this.$route.params.date;
	this.$httpSales.defaults.baseURL = this.$route.params.domain;
	this.statusTax = this.$route.params.idsStatus || [];
	this.loadDetail();
}
async function loadDetail() {
	this.loadingButton = true;
	this.params.page = this.currentPage;
	const id = this.$route.params.id;
	const params = {
		// statusTax: 2,
		// dateBilling: '2023-02-08',
		statusTax: this.statusTax && this.statusTax.length > 0 ? this.statusTax.map(p => p.id).join(',') : null,
		...this.params,
	};
	try {
		const response = await this.$httpSales.get(`subsidiaries/${id}/billing/RC`, { params });
		this.rows = response.data.map((row) => {
			const newRow = { ...row };
			newRow.isSelected = false;
			newRow.totalDoc = row.documentsRelated.length;
			return newRow;
		});
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	} finally {
		this.loadingButton = false;
	}
}
function setDate({ model, value }) {
	this.params[model] = format(value.value, 'YYYY-MM-DD');
}
function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadDetail();
}
async function sendKardex({ idSummary }) {
	const body = {
		ids: this.dataSelected.length > 0 ?
			this.dataSelected.map(p => p.idSummary) : [idSummary],
	};
	const idCompany = this.$route.params.id;
	await this.$httpSales.post(`subsidiaries/${idCompany}/billing/RC`, body);
	this.showNotification('Se envió correctamente');
	this.loadDetail();
}
function changePage(page) {
	this.currentPage = page;
	this.loadDetail();
}
function rowIsSelected(row) {
	if (row.isSelected) {
		this.dataSelected.push(row);
	} else {
		const index = this.rows.findIndex(ds => ds.idSummary === row.idSummary);
		if (index > -1) {
			this.dataSelected.splice(index, 1);
		}
	}
	this.checkAll = this.rows.every(element => element.isSelected);
}
function setDataSelected(row) {
	if (!row) {
		if (this.checkAll) {
			this.rows.forEach((rowData) => {
				const index = this.dataSelected.findIndex(d => d.idSummary === rowData.idSummary);
				if (index < 0) {
					this.dataSelected.push(rowData);
				}
			});
		} else {
			this.rows.forEach((rowData) => {
				const index = this.dataSelected.findIndex(d => d.idSummary === rowData.idSummary);
				if (index >= 0) {
					this.dataSelected.splice(index, 1);
				}
			});
		}
	} else {
		const index = this.dataSelected.findIndex(d => d.idSummary === row.idSummary);
		if (index < 0) {
			this.dataSelected.push(row);
		} else {
			this.dataSelected.splice(index, 1);
		}
	}
}
function allIsSelected(value) {
	this.checkAll = value;
	this.dataSelected = [];
	this.rows = this.rows.map((element) => {
		const newRow = { ...element };
		newRow.isSelected = value;
		if (value) {
			this.dataSelected.push(element);
		}
		return newRow;
	});
}
function data() {
	return {
		checkAll: false,
		columns: [
			{ id: 1, name: 'ID Resumen', checked: true, visible: true },
			{ id: 2, name: 'Tipo de Resumen', checked: true, visible: true },
			{ id: 3, name: 'Nro de Resumen', checked: true, visible: true },
			{ id: 4, name: 'Total Doc', checked: true, visible: true },
			{ id: 5, name: 'ERROR', checked: true, visible: true },
			{ id: 6, name: 'Fecha de Emisión', checked: true, visible: true },
			{ id: 7, name: 'Fecha de Referencia', checked: true, visible: true },
			{ id: 8, name: 'Acciones', checked: true, visible: true },
		],
		currentPage: 1,
		dataSelected: [],
		lastPage: 0,
		rows: [],
		states: [
			{
				id: 1,
				name: 'Sin Enviar',
			},
			{
				id: 2,
				name: 'En Proceso',
			},
			{
				id: 3,
				name: 'Validado',
			},
			{
				id: 4,
				name: 'Error',
			},
			{
				id: 5,
				name: 'Firmado',
			},
			{
				id: 6,
				name: 'Error al Enviar',
			},
			{
				id: 7,
				name: 'Error de SUNAT',
			},
		],
		statusTax: null,
		selectedValue: 'isSelected',
		loadingButton: false,
	};
}
export default {
	name: 'detail-billing',
	created,
	components: {
		appTooltipButton,
		dateComponent,
		appLoading,
	},
	data,
	methods: {
		allIsSelected,
		changePage,
		loadDetail,
		onSearch,
		setDate,
		sendKardex,
		rowIsSelected,
		setDataSelected,
	},
};
</script>

<style lang="scss" scoped>
.btn-search {
	background-color: map-get($colors, primary) !important;
	border-radius: 0px 5px 5px 0;
	height: 50px;
	width: 120px;
}
.width-1 {
	width: 95px;
}
.width-error {
	width: 355px;
}
</style>



// WEBPACK FOOTER //
// src/components/billing/detail-billing.vue